import { useTranslation } from "react-i18next";
import FormTemplate from "../../templates/FormTemplate";
import { Route, Routes, useMatch, useNavigate } from "react-router";
import { Box, Divider, Stack, Tab, Tabs } from "@mui/material";
import WebhookSettingsPage from "./WebhookSettings";
import ApiSettingsPage from "./ApiSettings";
import CreateWebhookPage from "./WebhookSettings/CreateWebhook";
import EditWebhookPage from "./WebhookSettings/EditWebhook";

export default function IntegrationSettingsPage() {
  const { t } = useTranslation("IntegrationSettingsPage");
  const navigate = useNavigate();
  const match = useMatch("/m/settings/integrations/:tab/:create?");
  const value = match?.params["tab"] || "webhooks";

  const handleChangeTab = (_: React.SyntheticEvent, newValue: string) => {
    navigate(`/m/settings/integrations/${newValue}`);
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <FormTemplate
      title={t("Title")}
      onCancel={handleClose}
      disableCancelButton
      disableEnter
      disableFooter
      disableSubmit
      noForm
      noPadding
    >
      <Stack height={1}>
        <Tabs
          value={value}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Tab label="Webhooks" value="webhooks" />
          <Tab label="API" value="api" />
        </Tabs>
        <Divider />
        <Box flexGrow={1} p={2} overflow="auto">
          <Routes>
            <Route index element={<WebhookSettingsPage />} />
            <Route path="webhooks">
              <Route index element={<WebhookSettingsPage />} />
              <Route path=":webhookId" element={<EditWebhookPage />} />
              <Route path="create" element={<CreateWebhookPage />} />
            </Route>
            <Route path="api">
              <Route index element={<ApiSettingsPage />} />
              <Route path=":apiId" element={<ApiSettingsPage />} />
              <Route path="create" element={<ApiSettingsPage />} />
            </Route>
          </Routes>
        </Box>
      </Stack>
    </FormTemplate>
  );
}
